import React from 'react'
import { Navigate } from 'react-router-dom'
import { pageScope } from '../lib/cssScope'

// Legacy route - redirect to new Governance section
const CustomerTrust: React.FC = () => {
  return (
    <div className={pageScope('customer-trust')} aria-hidden>
      <Navigate to="/governance/overview" replace />
    </div>
  )
}

export default CustomerTrust